import { Injectable, Inject } from '@angular/core';

export class SearchRequestDO {
	public agentId: String = null;
	public lineOfBusinessList: any = [];
	public leadRefNum: String = null;
	public baseProductCd: String = null;
	public productPlanOptionCd: String = null;
	public proposalNum: String = null;
	public statusCd: String = null;
	public firstName: String = null;
	public lastName: String = null;
	public contactPersonName: String = null;
	public companyName: String = null;
	public vehicleMakeCd: String = null;
	public vehicleModelCd: String = null;
	public vehicleVariant: String = null;

}